import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {License} from "../../../shared/interface/license";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {LicenseService} from "../../../shared/services/license.service";
import {takeUntil} from "rxjs/operators";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-license-details',
  templateUrl: './license-details.component.html',
  styleUrls: ['./license-details.component.scss']
})
export class LicenseDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  uuid?: string = null;
  licenseObject?: License;
  license: ReplaySubject<License> = new ReplaySubject<License>(1);
  modify = false;

  constructor(
    private route: ActivatedRoute,
    private licenseService: LicenseService,
    private snack: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.uuid = params.id;
        this.loadLicense();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
  }

  loadLicense(): void {
    this.licenseService.getLicense(this.uuid).subscribe((license: License) => {
      this.license.next(license);
      this.licenseObject = license;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych licencji', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
